function arraysOfObjectsEqual(a1, a2) {
  return a1.length === a2.length && a1.every((x) => objectInArray(x, a2));
}

function arraysEquals(a, b) {
  return a.length === b.length && a.every((v, i) => v === b[i]);
}

function objectInArray(obj, arr) {
  return arr.some((x) => objectsEqual(obj, x));
}

function objectsEqual(o1, o2) {
  return (
    typeof o1 === "object" &&
    typeof o2 === "object" &&
    o1.value === o2.value &&
    o1.text === o2.text &&
    Object.keys(o1).length === Object.keys(o2).length
  );
}

function ArrayIsEqual(array1, array2) {
  if (!array1 || !array2) return false;

  const array2Sorted = array2.slice().sort();
  return (
    array1.length === array2.length &&
    array1
      .slice()
      .sort()
      .every(function (value, index) {
        return value === array2Sorted[index];
      })
  );
}

export default { arraysOfObjectsEqual, arraysEquals, ArrayIsEqual };
